import * as E from './releasePopupStyled'
const ReleasePopup = () => {
  return (
    <div>
      <E.PopupTitleDiv>Your end of lease options</E.PopupTitleDiv>
      <div style={{ display: 'flex', flexFlow: 'row' }}>
        <E.PopupBlockDiv>
          <E.PopupBlockTitleDiv>Upgrade to a new car</E.PopupBlockTitleDiv>
          <E.PopupBlockSubtext>
            Just choose the car you want and start the leasing process again!
          </E.PopupBlockSubtext>
          <E.PopupBlockBulletListDiv>
            <ul>
              <li>
                You could immediately save 10% by avoiding GST upfront when you
                finance the car.
              </li>
              <li>
                You could save on the price of a car through our superior buying
                power - our experts will negotiate a great price for you!
              </li>
              <li>
                You’ll receive further tax savings - on top of everything you’ve
                already saved through your novated lease.
              </li>
              <li>
                You’ll continue enjoying the convenience benefits such as
                automatic budgeting - therefore saving you time and effort.
              </li>
              <li>
                Our dedicated leasing specialists help you find the right car
                and the right insurance - and we’ll take care of the paperwork
                for you!
              </li>
            </ul>
          </E.PopupBlockBulletListDiv>
        </E.PopupBlockDiv>

        <E.PopupBlockDiv>
          <E.PopupBlockTitleDiv>Extend your lease</E.PopupBlockTitleDiv>
          <E.PopupBlockSubtext>
            If you’re happy with your car, simply extend your current lease to
            keep it.
          </E.PopupBlockSubtext>
          <E.PopupBlockBulletListDiv>
            <ul>
              <li>
                You could receive further tax savings - on top of everything you
                may have already saved through your novated lease.
              </li>
              <li>
                You’ll continue enjoying the convenience benefits such as
                automatic budgeting - therefore saving you time and effort!
              </li>
              <li>
                Your regular car repayments will be lower than what you
                currently pay, which means more money will be deposited in your
                bank account each pay cycle.
              </li>
              <li>
                You’ll have a lower residual payment at the end of the term.
              </li>
              <li>
                You can still own your car outright at the end of the extension
                - at a cheaper price!
              </li>
            </ul>
          </E.PopupBlockBulletListDiv>
        </E.PopupBlockDiv>

        <E.PopupBlockDiv>
          <E.PopupBlockTitleDiv>Pay the residual</E.PopupBlockTitleDiv>
          <E.PopupBlockSubtext>
            You can pay the residual payment that’s due on the car, and own it
            outright. It’s important to that you know that if you choose this
            option:
          </E.PopupBlockSubtext>
          <E.PopupBlockBulletListDiv>
            <ul>
              <li>
                You’ll no longer enjoy the potential tax savings and convenience
                benefits of a novated lease.
              </li>
              <li>
                Your residual payment will be higher than if you extended your
                lease for another 12 months and then pay the residual.
              </li>
            </ul>
          </E.PopupBlockBulletListDiv>
        </E.PopupBlockDiv>
      </div>
    </div>
  )
}

export default ReleasePopup
